module.exports = __webpack_public_path__ + "images/emoji/white_circle.aad0942dee9569da7f8b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/white_circle.png
// module id = +nbV
// module chunks = 14